const lang = {
  page_title: '登録申請リスト',
  breadcrumb: {
    management: '登録申請リスト',
    details: '登録申請候補詳細',
  },

  explain:
    '森林クレジット創出登録申請エリア選定のためのシミュレーション条件を作成・編集する画面です。<br/>また、取り込んだ森林施業団地に対してのシミュレーション実行もこの画面で行います。',
  create: '新規登録',
  table: {
    no: 'NO',
    name: '申請登録名',
    total_forest_group: '総林小班数',
    total_forest_area: '総面積(ha)',
    total_co2_absorption_amount: '総CO2吸収量（t）',
    total_sales: '総売上（円）',
    updated_at: '最終更新日時',
    output_at: '申請書最終出力日時',
    output: '申請書',
    output_execute: '出力',
    credit_status: 'クレジット化',
    delete: '削除',
    confirm: {
      delete: '削除したデータは復旧できません。本当に削除しますか？',
    },
  },
}

export default lang
